<div class="sort-header">
   <entries-sort-button [btnDisabled]="(activePage$ | async)?.disableSort" [formControl]="sortFormControl"></entries-sort-button>
</div>
<toolbar-actions></toolbar-actions>